/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable  @typescript-eslint/no-unused-vars */
import {Injectable} from '@angular/core';
import {from} from 'rxjs';
import {loadModules} from 'esri-loader';

@Injectable({
    providedIn: 'root'
})
export class EsriModuleService {
    EsriMap: any;
    EsriFeatureLayer: any;
    SpatialReference: any;
    SnappingManager: any;
    GeometryService: any;
    ProjectParameters: any;
    QueryTask: any;
    Query: any;
    FeatureLayer: any;
    Graphic: any;
    ArcGISDynamicMapServiceLayer: any;
    ArcGISTiledMapServiceLayer: any;
    Navigation: any;
    Draw: any;
    SimpleMarkerSymbol: any;
    PictureMarkerSymbol: any;
    SimpleFillSymbol: any;
    SimpleLineSymbol: any;
    Color: any;
    Measurement: any;
    dom: any;
    keys: any;
    sniff: any;
    SimpleRenderer: any;
    geometry: any;
    geometryEngine: any;
    geodesicUtils: any;
    Polygon: any;
    Point: any;
    Polyline: any;
    DistanceParameters: any;
    Extent: any;
    units: any;
    AreasAndLengthsParameters: any;
    Edit: any;
    projection: any;
    Circle: any;
    Geoprocessor: any;
    config: any;
    registry: any;

    init() {
        return from(
            loadModules(
                [
                    'esri/map',
                    'esri/SpatialReference',
                    'esri/SnappingManager',
                    'esri/tasks/GeometryService',
                    'esri/tasks/ProjectParameters',
                    'esri/tasks/QueryTask',
                    'esri/tasks/query',
                    'esri/layers/FeatureLayer',
                    'esri/graphic',
                    'esri/layers/ArcGISDynamicMapServiceLayer',
                    'esri/layers/ArcGISTiledMapServiceLayer',
                    'esri/toolbars/navigation',
                    'esri/toolbars/draw',
                    'esri/symbols/SimpleMarkerSymbol',
                    'esri/symbols/PictureMarkerSymbol',
                    'esri/symbols/SimpleFillSymbol',
                    'esri/symbols/SimpleLineSymbol',
                    'esri/Color',
                    'esri/dijit/Measurement',
                    'dojo/dom',
                    'dojo/keys',
                    'esri/sniff',
                    'esri/renderers/SimpleRenderer',
                    'esri/geometry',
                    'esri/geometry/geometryEngine',
                    'esri/geometry/geodesicUtils',
                    'esri/geometry/Polygon',
                    'esri/geometry/Point',
                    'esri/geometry/Polyline',
                    'esri/tasks/DistanceParameters',
                    'esri/geometry/Extent',
                    'esri/units',
                    'esri/tasks/AreasAndLengthsParameters',
                    'esri/toolbars/edit',
                    'esri/geometry/projection',
                    'esri/geometry/Circle',
                    'esri/tasks/Geoprocessor',
                    'esri/config',
                    'dijit/registry',
                    'dojo/domReady!'
                ],
                {
                    version: '3.43'
                }
            ).then(
                ([
                    Map,
                    SpatialReference,
                    SnappingManager,
                    GeometryService,
                    ProjectParameters,
                    QueryTask,
                    Query,
                    FeatureLayer,
                    Graphic,
                    ArcGISDynamicMapServiceLayer,
                    ArcGISTiledMapServiceLayer,
                    Navigation,
                    Draw,
                    SimpleMarkerSymbol,
                    PictureMarkerSymbol,
                    SimpleFillSymbol,
                    SimpleLineSymbol,
                    Color,
                    Measurement,
                    dom,
                    keys,
                    sniff,
                    SimpleRenderer,
                    geometry,
                    geometryEngine,
                    geodesicUtils,
                    Polygon,
                    Point,
                    Polyline,
                    DistanceParameters,
                    Extent,
                    units,
                    AreasAndLengthsParameters,
                    Edit,
                    projection,
                    Circle,
                    Geoprocessor,
                    config,
                    registry
                ]) => {
                    this.EsriMap = Map;
                    this.EsriFeatureLayer = FeatureLayer;
                    this.FeatureLayer = FeatureLayer;
                    this.SpatialReference = SpatialReference;
                    this.SnappingManager = SnappingManager;
                    this.GeometryService = GeometryService;
                    this.ProjectParameters = ProjectParameters;
                    this.QueryTask = QueryTask;
                    this.Query = Query;
                    this.FeatureLayer = FeatureLayer;
                    this.Graphic = Graphic;
                    this.ArcGISDynamicMapServiceLayer = ArcGISDynamicMapServiceLayer;
                    this.ArcGISTiledMapServiceLayer = ArcGISTiledMapServiceLayer;
                    this.Navigation = Navigation;
                    this.Draw = Draw;
                    this.SimpleMarkerSymbol = SimpleMarkerSymbol;
                    this.PictureMarkerSymbol = PictureMarkerSymbol;
                    this.SimpleFillSymbol = SimpleFillSymbol;
                    this.SimpleLineSymbol = SimpleLineSymbol;
                    this.Color = Color;
                    this.Measurement = Measurement;
                    this.dom = dom;
                    this.keys = keys;
                    this.sniff = sniff;
                    this.SimpleRenderer = SimpleRenderer;
                    this.geometry = geometry;
                    this.geometryEngine = geometryEngine;
                    this.geodesicUtils = geodesicUtils;
                    this.Polygon = Polygon;
                    this.Point = Point;
                    this.Polyline = Polyline;
                    this.DistanceParameters = DistanceParameters;
                    this.Extent = Extent;
                    this.units = units;
                    this.ProjectParameters = ProjectParameters;
                    this.AreasAndLengthsParameters = AreasAndLengthsParameters;
                    this.Edit = Edit;
                    this.projection = projection;
                    this.Circle = Circle;
                    this.Geoprocessor = Geoprocessor;
                    this.config = config;
                    this.registry = registry;
                    console.log('Esri modules are loaded');
                }
            )
        );
    }
    getEsri() {
        return (window as any).esri;
    }
    modulesLoaded() {
        return !!this.EsriMap;
    }
}
